export default function activationStateBadgeClass(status) {
  // activation_state is not guaranteed not to be null
  switch (status?.toLowerCase()) {
    case "active":
      return "success";
    case "pending":
      return "warning";
    default:
      return "secondary";
  }
}
